import React, { useEffect, useState } from "react";

import { Button, Divider, Form, Modal, Spin, Table } from "antd";

import MyButton from "../../Button";

import Typography from "../../Typography";
import { COLORS } from "../../../constants/Colors";
import OrderForm from "../../OrderForm";
import SelectCustomerModal from "../../SelectCustomerModal";
import SelectAddrModal from "../../SelectAddrModal";
import useIsDesktop from "../../../utils/hooks/useIsDesktop";
import { instance } from "../../AxiosClient";
import GetProfile from "../../VariableStore";
import _ from "lodash";
import moment from "moment";
import { errorNotification, successNotification } from "../../Notification";
import { FormattedMessage, IntlProvider, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { triggerAction } from "../../../utils/redux/actions/globalReducer";
import QueueForm from "./createQueueForm";
import {
  getCustomerQueue,
  getLotParkList,
  getViewQueue,
} from "../../../controllers/queue/createModal";
import ModalAddProduct from "./addProduct";
import ParkingList from "../../ParkingList";
import { getQueueMessages } from "../../use-queue-api";
import { QueueContext } from "./queue-context";
import QueueView from "./viewForm";
import ConfirmCreateQueue from "./confirm_create";
import { useDebounce } from "../../../utils/hooks/useDebounce";
// import { useState } from "react";

const { confirm } = Modal;

const CreateQueueModal = (props) => {
  const {
    isOpen,
    onCancle,
    onSave,
    info,
    saveEditOrder,
    fromTracking,
    setTrigger,
    isView,
    recordQueue,
    isEdit,
    itemCate,
  } = props;
  const isDesktop = useIsDesktop();
  const intl = useIntl();
  const dispatch = useDispatch();
  const [isOpenSelectCustomer, setIsOpenSelectCustomer] = useState(false);
  const [isOpenSelectAddr, setIsOpenSelectAddr] = useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [searchCustomer, setSearchCustomer] = useState('');
    const debounch = useDebounce(searchCustomer, 500);
  const [addressData, setAddressData] = useState([]);
  const [event, setEvent] = useState(false);
  const [eventAddress, setEventAddress] = useState(false);
  const [formCustomer] = Form.useForm();
  const [isDisable, setIsDisable] = useState(true);
  const [contactData, setContactData] = useState([]);
  const [selectaddressData, setSelectAddressData] = useState([]);
  const [isOrder, setIsOrder] = useState(false);
  const [tempDataCus, setTempDataCus] = useState([]);
  const [tempDataAdd, setTempDataAdd] = useState([]);
  const [saveAddes, setSaveAddes] = useState([]);
  const [sizeProduce, setSizeProduce] = useState([]);
  const [productList, setProductList] = useState([]);
  const typeQueue = Form.useWatch("type", formCustomer);

  const customerId = GetProfile("customerId");
  const comCode = GetProfile("customerCode");

  const targetObject = { id: 2, name: "Bob" };
  const [loading, setLoading] = useState(false);

  //-------------------------------------------------------
  const [lotParkList, setLotParkList] = useState([]);
  const [deliveryType, setDeliveryType] = useState([]);
  const [visibleProduct, setVisibleProduct] = useState(false);
  const [addressCompany, setAddressCompany] = useState([]);
  const [recordItem, setRecordItem] = useState();
  const [tempData, setTempData] = useState();
  const [changeEdit, setChangetoEdit] = useState(false);
  const [eventStatus, setEventStatus] = useState(false);

  //--------------------------------------------------------
  const textTitle = isDesktop ? "14px" : "14px";
  //-------------------------------------------------------

  const columns = [
    {
      title: (
        <Typography
          className="pl-1"
          color={COLORS.Dark}
          size={textTitle}
          textAlign={"center"}
        >
          #
        </Typography>
      ),
      dataIndex: "index",
      key: "index",
      align: "center",
      width: isDesktop ? 50 : 180,
      render: (text, record, index) => index + 1,
    },
    {
      title: (
        <Typography className="pl-1" color={COLORS.Dark} size={textTitle}>
          <FormattedMessage
            id="createQueueFormProduct"
            defaultMessage="สินค้า"
          />
        </Typography>
      ),
      dataIndex: "itemName",
      key: "itemName",
      width: isDesktop ? 200 : 180,
      sorter: (a, b) => a.itemName.localeCompare(b.itemName),
    },
    {
      title: (
        <Typography color={COLORS.Dark} size={textTitle} textAlign={"center"}>
          <FormattedMessage id="createQueueFormQty" defaultMessage="จำนวน" />
        </Typography>
      ),
      dataIndex: "qty",
      key: "qty",
      align: "center",
      width: isDesktop ? 150 : 120,
      sorter: (a, b) => a.qty - b.qty,
    },
    {
      title: (
        <Typography color={COLORS.Dark} size={textTitle}>
          <FormattedMessage id="createQueueFormUnit" defaultMessage="หน่วย" />
        </Typography>
      ),
      dataIndex: "uom",
      key: "uom",
      width: isDesktop ? 150 : 100,
    },
  ];

  useEffect(() => {
    const getAPI = async () => {
      try {
        const body = {
          customerId: customerId,
        };
        const response = await getLotParkList(body);
        console.log("AAPPII", response);

        setLotParkList(_.get(response, "dataCarLot"));
        // setCustomerData(_.get(response, "dataMarket"));
        setDeliveryType(_.get(response, "deliveryType"));
        setAddressCompany(_.get(response, "getAddress[0]"));
      } catch (error) {}
    };

    if (isOpen === true) {
      getAPI();
    }
  }, [isOpen, event]);

  useEffect(() => {
    const getAPI = async () => {
      try {
        const body = {
          search: debounch,
          pageNumber: 1,
          limit: 100,
        };
        const response = await getCustomerQueue(body);
        setCustomerData(_.get(response, "data.data.dataMarket"));
      } catch (error) {}
    };

    if (isOpen === true) {
      getAPI();
    }
  }, [isOpen,debounch ]);

  useEffect(() => {
    if (comCode && customerId && isOpen === true) {
      getSize();
    }
  }, [isOpen, event]);

  useEffect(() => {
    if (changeEdit === true) {
      if (changeEdit) {
        // getEditCustomer();
        // getEditAddress(
        //   _.get(recordQueue, "contact.customerContactId"),
        //   _.get(recordQueue, "destination.customer_address_book_id")
        // );

        formCustomer.setFieldsValue({
          lotpark: _.get(recordQueue, "carLotContractId"),
          customer: _.get(recordQueue, "marketblockContractId"),
          type: _.get(recordQueue, "orderType"),
          carplate:
            _.get(recordQueue, "orderType") === "SELF-DO"
              ? _.get(recordQueue, "carLicensePlat")
              : undefined,
          ref: _.get(recordQueue, "referenceNo")
            ? _.get(recordQueue, "referenceNo")
            : "",
        });
        setIsDisable(false);
      }
    }
  }, [changeEdit]);

  useEffect(() => {
    const getAPI = async () => {
      try {
        const body = {
          customerId: customerId,
        };
        const response = await getViewQueue(_.get(recordQueue, "_id"));
        console.log("AAPPII", response);

        const responseData = _.get(response, "data.data");

        const tableNew = _.map(_.get(responseData, "pacelDetails"), (item) => {
          if (_.get(responseData, "detailTypeCode") === "deliveryOrderItem") {
            return {
              _id: _.get(item, "_id"),
              itemMasterId: _.get(item, "size.item_master_id"),
              itemCode: _.get(item, "size.item_code"),
              itemName:
                (_.get(item, "size.item_brand_name") || "") +
                " " +
                (_.get(item, "size.item_model_name") || "") +
                " " +
                (_.get(item, "size.item_name") || ""),
              item_brand_name: _.get(item, "size.item_brand_name"),
              item_model_name: _.get(item, "size.item_model_name"),
              item_name: _.get(item, "size.item_name"),
              qty: _.get(item, "size.qty"),
              uomId: _.get(item, "size.uom.uom_id"),
              uom: _.get(item, "size.uom.uom_name_en"),
              index: _.get(item, "parcelIndex"),
            };
          } else {
            return {
              index: _.get(item, "parcelIndex"),
              _id: _.get(item, "_id"),
              parcelNo: _.get(item, "parcelNo"),
              parcelId: _.get(item, "parcelNo"),
              size: _.get(item, "size"),
              weight: _.get(item, "weight"),
              shippingPrice: "0",
              statusCode: _.get(item, "status.statusCode"),
            };
          }
        });

        setTempData(responseData);
        setProductList(tableNew);
      } catch (error) {}
    };

    if (_.size(recordQueue) > 0 && isOpen) {
      getAPI();
    }
  }, [isOpen, eventStatus]);

  const getSize = async () => {
    try {
      const response = await instance.get(
        `v5/order/manager/company/${comCode}/web/ordersize/loopmerchant?sizeCode=s`
      );
      setSizeProduce(_.get(response, "data.data.list[0]"));
    } catch (error) {}
  };

  const handleClickSave = () => {
    const comCode = GetProfile("customerCode");
    setLoading(true);
    formCustomer
      .validateFields()
      .then((values) => {
        confirmModal(values);
      })
      .catch((info) => {
        errorNotification(
          intl.formatMessage({
            id: "saveErrorNotification",
            defaultMessage: "Failed",
          })
        );
        setLoading(false);
      });
  };

  const saveQueue = async (values) => {
    const mapItem = _.map(productList, (i) => ({
      _id: i._id ? i._id : undefined,
      statusCode: "open",
      shippingPrice: "0",
      size: i,
    }));

    const FilterCarLot = _.get(
      _.filter(lotParkList, (i) => {
        return i.id === values.lotpark;
      }),
      "[0]"
    );

    const FilterMarket = _.get(
      _.filter(customerData, (i) => {
        return i.id === values.customer;
      }),
      "[0]"
    );

    console.log(
      "FFFFFF",
      FilterCarLot,
      "F:",
      _.get(FilterMarket, "customerDetail")
    );

    const DetailMarket = _.get(FilterMarket, "customerDetail");

    const body = {
      detailTypeCode: "deliveryOrderItem",
      parcelDetail: mapItem,
      customerDetail: {
        customerId: _.get(DetailMarket, "customer_id"),
        comtomerName: _.get(DetailMarket, "comtomer_name"),
        phone: _.get(DetailMarket, "phone"),
        profileImg: _.get(DetailMarket, "profile_img"),
      },
      sourceDetail: {
        address_name:
          _.get(FilterCarLot, "serialNo") +
          " " +
          _.get(FilterCarLot, "assetName"), //มาจากdataCarLot serialNo assetName
        address: _.get(addressCompany, "full_address"), // Company
        lat: _.get(addressCompany, "location_lat"), // Company
        lng: _.get(addressCompany, "location_lng"), // Company
      },
      contactDetail: {
        // Market
        customerContactName: _.get(DetailMarket, "comtomer_name"), // Market CustomerName
        customerContactPhone: _.get(DetailMarket, "phone"), // Market CustomerPhone
        toSave: false,
      },
      destinationDetail: {
        address_name:
          _.get(FilterMarket, "serialNo") +
          " " +
          _.get(FilterMarket, "customerDetail.comtomer_name"), //มาจาก dataMarket  serialNo CustomerName
        address: _.get(addressCompany, "full_address"), // Company
        lat: _.get(addressCompany, "location_lat"), // Company
        lng: _.get(addressCompany, "location_lng"), // Company
      },
      referenceNo: values.ref,

      carLicensePlat: values.type === "SELF-DO" ? values.carplate : undefined,
      carLotContractId: values.lotpark, // จาก Carlot
      marketblockContractId: values.customer, // จาก Market
      serialNoCarlot: _.get(FilterCarLot, "serialNo"),
      assetNameCarlot: _.get(FilterCarLot, "assetName"),
      assetIdCarlot: _.get(FilterCarLot, "assetId"),
      assetBrandIdCarlot: _.get(FilterCarLot, "serialNo"),
      assetClassIdCarlot: _.get(FilterCarLot, "serialNo"),
      serialNoMarket: _.get(FilterMarket, "serialNo"),
      assetNameMarket: _.get(FilterMarket, "assetName"),
      assetIdMarket: _.get(FilterMarket, "assetId"),
      orderType: values.type,
      deliveryDate: moment().format("YYYY-MM-DD"),
      deliveryTime: moment().format("H:mm"),
      orderStatus: "confirmed",
    };

    console.log("LogBody", recordQueue);

    const payload = {
      apiMethod: "post",
      urlQueue: `/queue/manager/company/${comCode}/channgedeliveryorder`,
      apiUrl: `${process.env.REACT_APP_URL_Tracking}/order-manager/v5/order/manager/company/${comCode}/web/deliveryorderv2`,
      payload: body,
    };

    const payloadUpdate = {
      apiMethod: "put",
      urlQueue: `/queue/manager/company/${comCode}/channgedeliveryorder`,
      apiUrl: `${
        process.env.REACT_APP_URL_Tracking
      }/order-manager/v5/order/manager/company/${comCode}/web/deliveryorderv2/${_.get(
        tempData,
        "orderId"
      )}`,
      payload: body,
    };

    try {
      const response = await getQueueMessages(
        changeEdit ? payloadUpdate : payload
      );
      console.log("getQueueMessages data:", response);
      if (response.status.code === 200) {
        successNotification(_.get(response, "status.message"));
        setTrigger((cur) => !cur);
        setLoading(false);
        formCustomer.resetFields();
        setProductList([]);
      } else {
        setLoading(false);
        errorNotification(_.get(response, "status.message"));
      }
    } catch (error) {
      setLoading(false);
      console.log("Error fetching queue messages:", error, error.response);
      errorNotification(_.get(error, "response.data.status.message"));
    }
    setLoading(false);
    handleCancelThisModal();
  };

  const getOrdersList = async (payload) => {
    const search = {
      "contact.customerContactName": "",
      "contact.customerContactPhone": "",
      "customer.comtomerName": "",
      "destination.address": "",
      orderNo: payload,
      sizesizeName: "",
      sourceaddress: "",
      weightTxt: "",
    };

    const body = {
      search: search,
      "customer.customerId": customerId,
      limit: 1,
    };
    try {
      const response = await instance.post(
        `/v5/order/manager/company/${comCode}/web/deliveryorder/report/loopmerchant`,
        body
      );

      if (isEdit) {
        if (fromTracking === undefined) {
          // setFocusShipmentDetail(_.findLast(response.data.data.list))
          saveEditOrder(response.data.data.list);
        } else {
          saveEditOrder(response.data.data.list);
        }
      } else {
        onSave(_.findLast(response.data.data.list));
      }
    } catch (error) {
      return error.response.data;
    }
  };

  // const handleClickCancelEdit = () => {
  //   setIsEdit(false);
  // };

  const handleSelectName = (values, editvalue) => {
    if (_.size(editvalue) > 0) {
      if (_.size(editvalue) > 1) {
        setContactData(
          _.get(
            _.filter(customerData, (e) => {
              return e.customerContactId === values;
            }),
            "[0]"
          )
        );
      } else {
        setContactData(_.get(editvalue, "[0]"));
      }

      editvalue = [];
    } else {
      formCustomer.setFieldsValue({
        phone: _.get(
          _.filter(customerData, (e) => {
            return e.customerContactId === values;
          }),
          "[0].customerContactPhone"
        ),
        address: "",
      });
      setContactData(
        _.get(
          _.filter(customerData, (e) => {
            return e.customerContactId === values;
          }),
          "[0]"
        )
      );
    }

    // getDataAddress(values);
    setIsDisable(false);
  };

  const handleClickViewAllCustomer = () => {
    setIsOpenSelectCustomer(true);
  };

  const handleClickViewAllAddr = () => {
    setIsOrder(true);
    setIsOpenSelectAddr(true);
  };

  const handleCloseSelectModal = () => {
    setIsOpenSelectCustomer(false);
    setIsOpenSelectAddr(false);
  };

  const handleSelectAddress = (values, addressEdit) => {
    const address = _.get(
      _.filter(isEdit ? addressEdit : addressData, (e) => {
        return e.customerAddressBookId === values;
      }),
      "[0]"
    );

    setSelectAddressData({
      customer_address_book_id: _.get(address, "customerAddressBookId"),
      address_name: _.get(address, "addressName"),
      address: _.get(address, "address"),
      // address: _.get(address, 'fullAddress') ? _.get(address, 'address') + ',' + _.get(address, 'fullAddress') : _.get(address, 'address'),
      lat: _.get(address, "lat"),
      lng: _.get(address, "lng"),
    });
    // setSelectAddressData((e) => ({ ...e, address: _.get(address, 'address') + ',' + _.get(address, 'fullAddress') }));
  };

  const handleCancelThisModal = () => {
    onCancle();
    formCustomer.resetFields();
    setIsDisable(true);
    setCustomerData([]);
    setAddressData([]);
    setTempDataCus([]);
    setTempDataAdd([]);
    setProductList([]);
    setTempData([]);
    setChangetoEdit(false);
    setLoading(false);
  };

  const openAddProduct = () => {
    setVisibleProduct(true);
  };

  const closeAddProduct = () => {
    setVisibleProduct(false);
    setRecordItem([]);
  };

  const contentAction = (record) => {
    console.log("recordrecordrecord", record);

    return (
      <div style={{ display: "grid" }}>
        <div>
          <Button
            style={{ width: 100, color: COLORS.Primary }}
            type="link"
            ghost
            onClick={() => {
              editItem(record);
            }}
          >
            <FormattedMessage id="btnEdit" defaultMessage="Edit" />
          </Button>
        </div>

        <div>
          <Button
            style={{ width: 100, color: COLORS.Primary }}
            type="link"
            ghost
            onClick={() => {
              deleteItem(record);
            }}
          >
            <FormattedMessage id="btnDelete" defaultMessage="Delete" />
          </Button>
        </div>
      </div>
    );
  };

  const editItem = (record) => {
    console.log("RECOOORD", record);

    setRecordItem(record);
    setVisibleProduct(true);
  };

  const deleteItem = (value) => {
    const filterSelect = _.filter(productList, (item) => {
      return (
        (_.get(item, "uomId") !== _.get(value, "uomId") &&
          _.get(item, "itemMasterId") === _.get(value, "itemMasterId")) ||
        _.get(item, "itemMasterId") !== _.get(value, "itemMasterId")
      );
    });
    setProductList(filterSelect);
  };

  const onChangeTo = async (status) => {
    setLoading(true);

    const body = {
      orderStatus: status,
      comment: "",
    };

    const payload = {
      apiMethod: "put",
      urlQueue: `/queue/manager/company/${comCode}/channgedeliveryorder`,
      apiUrl: `${
        process.env.REACT_APP_URL_Tracking
      }/order-manager/v5/order/manager/company/${comCode}/web/deliveryorder-status/${_.get(
        recordQueue,
        "_id"
      )}`,
      payload: body,
    };

    try {
      const response = await getQueueMessages(payload);
      console.log("getQueueMessages data:", response);
      if (response.status.code === 200) {
        successNotification(_.get(response, "status.message"));
        setEventStatus((prev) => !prev);
      } else {
        errorNotification(_.get(response, "status.message"));
      }
    } catch (error) {
      console.log("Error fetching queue messages:", error, error.response);
      errorNotification(_.get(error, "response.data.status.message"));
    }

    console.log("onChangeTo isLoad", loading);

    setLoading(false);
    setTrigger((event) => !event);
  };
  const confirmModal = (values) => {
    const modal = confirm({
      title: (
        <Typography
          isBold
          color={COLORS.Purple}
          style={{ lineHeight: "1.5" }}
          size="18px"
          className="text-left pt-2"
        >
          <IntlProvider>
            <FormattedMessage
              id="titleConfirmCreateQueue"
              defaultMessage="คุณยืนยันการเพิ่มคิวหรือไม่"
            />
          </IntlProvider>
        </Typography>
      ),
      icon: null,
      style: { marginLeft: "-10px" },
      width: isDesktop ? 550 : "100%",
      centered: true,
      footer: (
        <IntlProvider>
          <div
            style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
          >
            <MyButton
              onClick={() => {
                modal.destroy();
                setLoading(false);
              }}
              style={{
                width: isDesktop ? "25%" : "48%",
              }}
            >
              <FormattedMessage id="btnNo" defaultMessage="No" />
            </MyButton>
            <MyButton
              disabled={_.size(productList) > 0 ? false : true}
              isPrimary
              // onClick={handleClickSave}
              onClick={() => {
                saveQueue(values);
                modal.destroy();
              }}
              style={{
                width: isDesktop ? "25%" : "48%",
              }}
            >
              <FormattedMessage id="btnSave" defaultMessage="Yes" />
            </MyButton>{" "}
          </div>
        </IntlProvider>
      ),
    });
  };

  return (
    <QueueContext.Provider
      value={{
        productList,
        setProductList,
      }}
    >
      <Modal
        className="custom-modal"
        style={{ marginTop: isDesktop ? "-50px" : null }}
        maskClosable={false}
        title={
          isEdit && changeEdit === false ? (
            <Typography
              color={isDesktop ? COLORS.Purple : COLORS.GreenBrown}
              isBold
              size="16px"
              className={isDesktop ? "pb-0" : "text-center pb-2"}
            >
              <FormattedMessage
                id="modalQueueView"
                defaultMessage="คิวนำส่งสินค้า"
              />{" "}
              {_.get(tempData, "orderNo")}
            </Typography>
          ) : (
            <Typography
              color={isDesktop ? COLORS.Purple : COLORS.GreenBrown}
              isBold
              size="16px"
              className={isDesktop ? "pb-0" : "text-center pb-2"}
            >
              <FormattedMessage
                id="addQueueModal"
                defaultMessage="เพิ่มคิวนำส่งสินค้า"
              />
            </Typography>
          )
        }
        open={isOpen}
        onOk={() => {}}
        onCancel={() => {
          onCancle();
          setIsDisable(true);
          formCustomer.resetFields();
          handleCancelThisModal();
        }}
        width={isDesktop ? 680 : "100%"}
        centered={isDesktop ? true : false}
        footer={[
          isDesktop ? (
            isView && changeEdit === false ? (
              _.get(tempData, "orderStatus") !== "open" ? (
                <MyButton
                  onClick={() => {
                    handleCancelThisModal();
                  }}
                  style={{
                    width: isDesktop ? "25%" : "48%",
                  }}
                >
                  <FormattedMessage id="btnCancel" defaultMessage="ยกเลิก" />
                </MyButton>
              ) : (
                <>
                  {" "}
                  <MyButton
                    onClick={() => {
                      handleCancelThisModal();
                    }}
                    style={{
                      width: isDesktop ? "25%" : "48%",
                    }}
                  >
                    <FormattedMessage id="btnCancel" defaultMessage="ยกเลิก" />
                  </MyButton>
                  <MyButton
                    isPrimary
                    onClick={() => onChangeTo("confirmed")}
                    style={{
                      width: isDesktop ? "25%" : "48%",
                    }}
                  >
                    <FormattedMessage
                      id="btnConfirmQueue"
                      defaultMessage="คอนเฟิร์มคิว"
                    />
                  </MyButton>{" "}
                  <MyButton
                    isPrimary
                    onClick={() => {
                      setChangetoEdit(true);
                    }}
                    style={{
                      width: isDesktop ? "25%" : "48%",
                    }}
                  >
                    <FormattedMessage id="btnEdit" defaultMessage="Edit" />
                  </MyButton>{" "}
                </>
              )
            ) : (
              <>
                {" "}
                <MyButton
                  onClick={() => {
                    handleCancelThisModal();
                  }}
                  style={{
                    width: isDesktop ? "25%" : "48%",
                  }}
                  disabled={loading ? true : false}
                >
                  <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
                </MyButton>
                <MyButton
                  disabled={
                    _.size(productList) > 0 ? (loading ? true : false) : true
                  }
                  isPrimary
                  // onClick={handleClickSave}
                  onClick={() => {
                    handleClickSave();
                  }}
                  style={{
                    width: isDesktop ? "25%" : "48%",
                  }}
                >
                  <FormattedMessage id="btnSave" defaultMessage="Save" />
                </MyButton>{" "}
              </>
            )
          ) : isView && changeEdit === false ? (
            _.get(tempData, "orderStatus") !== "open" ? (
              <MyButton
                onClick={() => {
                  handleCancelThisModal();
                }}
                style={{
                  width: "100%",
                  marginBottom: "10px",
                }}
              >
                <FormattedMessage id="btnCancel" defaultMessage="ยกเลิก" />
              </MyButton>
            ) : (
              <>
                {" "}
                <MyButton
                  onClick={() => {
                    handleCancelThisModal();
                  }}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                  }}
                >
                  <FormattedMessage id="btnCancel" defaultMessage="ยกเลิก" />
                </MyButton>
                <MyButton
                  isPrimary
                  onClick={() => onChangeTo("confirmed")}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    marginLeft: "-8px",
                  }}
                >
                  <FormattedMessage
                    id="btnConfirmQueue"
                    defaultMessage="คอนเฟิร์มคิว"
                  />
                </MyButton>{" "}
                <MyButton
                  isPrimary
                  onClick={() => {
                    setChangetoEdit(true);
                  }}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    marginLeft: "-8px",
                  }}
                >
                  <FormattedMessage id="btnEdit" defaultMessage="Edit" />
                </MyButton>{" "}
              </>
            )
          ) : (
            <div>
              <MyButton
                disabled={
                  _.size(productList) > 0 ? (loading ? true : false) : true
                }
                isPrimary
                // onClick={handleClickSave}
                onClick={() => {
                  handleClickSave();
                }}
                style={{
                  width: isDesktop ? "25%" : "100%",
                  marginBottom: "10px",
                }}
              >
                <FormattedMessage id="btnSave" defaultMessage="Save" />
              </MyButton>
              <MyButton
                onClick={() => {
                  handleCancelThisModal();
                }}
                style={{
                  width: isDesktop ? "25%" : "100%",
                  marginLeft: "0px",
                }}
                disabled={loading ? true : false}
              >
                <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
              </MyButton>
            </div>
          ),
        ]}
      >
        <Spin spinning={loading}>
          <div>
            {isView && changeEdit === false ? (
              <QueueView
                form={formCustomer}
                columns={columns}
                productList={productList}
                recordQueue={tempData}
                deliveryType={deliveryType}
              />
            ) : (
              <QueueForm
                isEdit={isEdit}
                onClickViewAllCustomer={handleClickViewAllCustomer}
                customerData={customerData}
                form={formCustomer}
                isDisable={isDisable}
                setIsDisable={setIsDisable}
                handleSelectName={handleSelectName}
                lotParkList={lotParkList}
                deliveryType={deliveryType}
                columns={columns}
                productList={productList}
                openAddProduct={openAddProduct}
                contentAction={contentAction}
                // isEdit={_.size(recordQueue) > 0 ? true : false}
              />
            )}

            <SelectCustomerModal
              isOpen={isOpenSelectCustomer}
              onCancle={handleCloseSelectModal}
              customerData={customerData}
              setIsOpenSelectCustomer={setIsOpenSelectCustomer}
              setCustomerData={setCustomerData}
              setEvent={setEvent}
              formCustomer={formCustomer}
              handleSelectName={handleSelectName}
              tempDataCus={tempDataCus}
              setTempDataCus={setTempDataCus}
              setSearchCustomer={setSearchCustomer}
            />
            <SelectAddrModal
              isOpen={isOpenSelectAddr}
              onCancle={handleCloseSelectModal}
              addressData={addressData}
              setIsOpenSelectAddr={setIsOpenSelectAddr}
              setAddressData={setAddressData}
              setEvent={setEventAddress}
              formCustomer={formCustomer}
              isOrder={isOrder}
              setIsOrder={setIsOrder}
              contactData={contactData}
              tempDataAdd={tempDataAdd}
              setTempDataAdd={setTempDataAdd}
              handleSelectAddress={handleSelectAddress}
            />
            <ModalAddProduct
              visible={visibleProduct}
              onCancel={closeAddProduct}
              setTableData={setProductList}
              tableData={productList}
              recordItem={recordItem}
              itemCate={itemCate}
            />
          </div>
        </Spin>
      </Modal>
    </QueueContext.Provider>
  );
};

export default CreateQueueModal;
